module.exports = __webpack_public_path__ + "logosheader.10db3d63.png";